import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'

import GoogleAnalyticsProvider from '@/components/providers/GoogleAnalyticsProvider'
import LocalCodeHighlightAdapterProvider from '@/components/providers/LocalCodeHighlightAdapterProvider'
import PostHogProvider from '@/components/providers/PostHogProvider'
import { ReactQueryProvider } from '@/components/providers/ReactQueryProvider'
import { ModalsProvider } from '@mantine/modals'

import { cssVariablesResolver, theme } from '../mantine-theme'

import '@mantine/charts/styles.css'
import '@mantine/code-highlight/styles.css'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/spotlight/styles.css'

import notificationClasses from '@/notifications.module.css'
import '../globals.css'

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        title: 'Tower',
      },
      {
        name: 'description',
        content: 'Ship workflows fast on proven lakehouse infrastructure.',
      },
    ],
  }),
  component: () => (
    <GoogleAnalyticsProvider>
      <PostHogProvider>
        <ReactQueryProvider>
          <MantineProvider
            theme={theme}
            defaultColorScheme="dark"
            cssVariablesResolver={cssVariablesResolver}
          >
            <LocalCodeHighlightAdapterProvider>
              <ModalsProvider>
                <Outlet />
              </ModalsProvider>
              <Notifications position="top-center" classNames={notificationClasses} />
            </LocalCodeHighlightAdapterProvider>
          </MantineProvider>

          <TanStackRouterDevtools />
          <ReactQueryDevtools buttonPosition="bottom-left" />
        </ReactQueryProvider>
      </PostHogProvider>
    </GoogleAnalyticsProvider>
  ),
})
